import {useFetchLeads} from '~/services'
import {DashboardPage} from '../components/dashboard_page'
import {graphVariantsTaxonomy} from './graph_variants_taxonomy'

export const LeadsDashboard = () => {
	useFetchLeads()

	return <DashboardPage graphVariantsTaxonomy={graphVariantsTaxonomy} name="leads" />
}
